import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/lang";
import { toast } from "sonner";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function Login() {
    const { t } = useLang();
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(email, password);
            toast.success("OK");
            const pendingInvite = sessionStorage.getItem("vivoz_pending_invite");
            const pendingReferral = sessionStorage.getItem("vivoz_pending_referral");
            nav(pendingInvite ? `/join/${pendingInvite}` : pendingReferral ? `/r/${pendingReferral}` : u.role === "admin" ? "/admin" : "/dashboard");
        } catch (err) {
            toast.error(t("auth.error_credentials"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <div className="max-w-md mx-auto px-6 pt-20 pb-24">
                <div className="mono-label mb-4">/ LOGIN</div>
                <h1 className="font-display text-4xl md:text-5xl mb-3 tracking-tight" data-testid="login-title">
                    {t("auth.login_title")}
                </h1>
                <p className="text-slate-600 mb-10">{t("auth.login_sub")}</p>
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <label className="mono-label block mb-2">{t("auth.email")}</label>
                        <input
                            data-testid="login-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-transparent border border-slate-300 px-4 py-3 rounded-sm focus:border-brand outline-none transition-colors"
                        />
                    </div>
                    <div>
                        <label className="mono-label block mb-2">{t("auth.password")}</label>
                        <input
                            data-testid="login-password-input"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-transparent border border-slate-300 px-4 py-3 rounded-sm focus:border-brand outline-none transition-colors"
                        />
                        <div className="text-right mt-2">
                            <Link to="/forgot-password" className="text-xs text-slate-500 hover:text-brand" data-testid="forgot-password-link">
                                {t("auth.forgot_password")}
                            </Link>
                        </div>
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-primary w-full justify-center"
                        data-testid="login-submit-btn"
                    >
                        {loading ? "..." : t("auth.login_btn")}
                    </button>
                </form>
                <div className="flex items-center gap-4 my-8">
                    <div className="flex-1 h-px bg-slate-200" />
                    <span className="mono-label text-slate-400">{t("auth.or")}</span>
                    <div className="flex-1 h-px bg-slate-200" />
                </div>
                <GoogleSignInButton />
                <p className="mt-8 text-sm text-slate-500">
                    {t("auth.no_account")}{" "}
                    <Link to="/register" className="text-brand hover:underline" data-testid="login-go-register">
                        {t("nav.signup")}
                    </Link>
                </p>
            </div>
        </div>
    );
}
